export class Mesure {
    nom: string = "";
    reference: string = "";
    unite_id: string = "";
    user_id: string = "";
  
    private errorMessage: string;
  
    constructor() {
      this.errorMessage = "";
    }
  
    // Récupérer le message d'erreur
    getErrorMessage(): string {
      return this.errorMessage;
    }
  
    // Vérifier si on peut sauvegarder
    canSave(): boolean {
      // Vérification du nom
      if (!this.nom || this.nom.trim() === "") {
        this.errorMessage = "Veuillez saisir le nom du produit";
        return false;
      }
      
  
      // Si tous les champs sont valides
      this.errorMessage = ""; // Réinitialiser le message d'erreur
      return true;
    }
  }
  